define('app/dashboard/AlertEntitiesGridView',['require','app/dashboard/DashboardEntitiesGridView','glu/grid','glu/dialog','glu/collection','app/visualizations/FormatFactory','app/visualizations/ReportNameCell','app/app','glu/util'],function(require) {

	'use strict';
	var
		DashboardEntitiesGridView = require('app/dashboard/DashboardEntitiesGridView'),
		Grid = require('glu/grid'),
		Dialog = require('glu/dialog'),
		Collection = require('glu/collection'),
		FormatFactory = require('app/visualizations/FormatFactory'),
		ReportNameCell = require('app/visualizations/ReportNameCell'),
		App = require('app/app'),
		_ = require('glu/util');


	var dateFormat = FormatFactory.formatterForType('DATETIME');

	return DashboardEntitiesGridView.extend({
		initialize: function() {
			// this will allow to use mock dialog in unit tests
			this.dialog = Dialog;
			this.items = this.options.items;
			this.itemType = this.options.itemType;

			//listening for domain report/segment collections to change
			// and synchronize grid data accordingly
			if (this.items !== undefined) {
				this.listenTo(this.items, 'add', this.addEntity);
				this.listenTo(this.items, 'remove', this.removeEntity);
			}

			this.data = new Collection([]);

			var columns = [{
				field: 'entityViewType',
				label: 'View',
				title: 'If report, this will show current visual format of it',
				safe: false,
				width: 50
			}, {
				field: 'namelink',
				label: 'Alert',
				title: 'The name of the element',
				cellView: ReportNameCell,
				safe: false,
				width: 200
			}, {
				field: 'description',
				label: 'Description',
				title: 'The description',
				width: 200
			}, {
				field: 'dateModified',
				label: 'Date Modified',
				title: 'Date of last modification (New York time zone)',
				width: 200,
				type: 'date',
				format: dateFormat
			}, {
				field: 'range',
				label: 'Alert Type',
				title: 'The range of the alert',
				width: 140
			}, {
				field: 'value',
				label: 'Value',
				title: 'Value',
				width: 140
			}, {
				field: 'schedule',
				label: 'Schedule',
				title: 'The schedule of the alert',
				width: 140
			}, {
				field: 'remove',
				label: '',
				title: 'Delete',
				safe: false,
				sortable: false,
				width: 50
			}];

			this.grid = new Grid({
				collection: this.data,
				columns: columns,
				loadingViewText: 'Searching for reports...',
				emptyViewText: 'No reports found.'
			});
		},

		deleteHandler: function(e) {
			//find entity id
			var eid = this.$(e.target).data('eid');
			if (!eid) {
				throw Error('Entity id is not associated with delete button');
			}
			//find if this is a report or segment
			var dataEl = this.data.get(eid);
			if (!dataEl) {
				throw Error('Entity id \'' + eid + '\'is not found in grid data collection');
			}

			//pull entity and associated collection from domain	
			var entityCollection = this.items;
			var entity = entityCollection.get(eid);
			if (!entity) {
				throw Error('Entity \'' + eid + '\' does not exist in domain');
			}

			//confirmation dialog
			this.dialog.confirm('You will no longer receive scheduled notifications. Are you sure you want to delete this alert?', 'Delete Alert', function(ok) {
				if (ok) { // Logic if 'Yes' is clicked
					//this 'delete()' will trigger the DELETE HTTP request
					entity.delete().then(function() {
						entityCollection.remove(entity); //this will remove entity from domain report/segment collections
						App.openReports.remove(entity.getId()); //this will remove entity from navigation
					});
					return;
				}
			});
		},

		addEntity: function(entity) {
			if (_.isFunction(this.options.filter)) {
				var toAdd;
				if (this.options.dashboard !== undefined) {
					toAdd = this.options.filter(entity, this.options.dashboard.get('owner'));
				} else {
					toAdd = this.options.filter(entity);
				}
				if (!toAdd) {
					return;
				}
			} else if (this.options.filter) {
				throw new Error('Invalid \'filter\' option. It must be a filtering function');
			}

			// filter by search box
			if (this.isFiltered(entity)) {
				return;
			}

			//if this is a Report instance or Segment
			var isReport = _.isFunction(entity.getWidgetType);

			var entityViewTypeDiv = '<div class="dashbrdgrid-report-visual-style icon-clock" />';

			//delete button
			var remove = '';
			if (entity.canBeDeleted()) {
				remove += '<div style="position:relative">';
				remove += '<span class="icon-close dashbrdgrid-report-delete" title="Delete the report" data-eid="' + entity.id + '"></span>';
				remove += '</div>';
			}

			var selectedColumn = entity.getSelectedColumn();
			var threshold = entity.getThreshold();
			var value;
			var isPercentage = false;
			var isTimespan = false;
			var formatter = FormatFactory.formatterForType('TIMESPAN');
			if (selectedColumn) {
				isPercentage = entity.isColumnPercentage(selectedColumn);

				// check for timestamp
				if (!isPercentage) {
					var column = entity.getColumnByName(selectedColumn);
					if (column && column.getAggregation() !== 'COUNT' && column.getAggregation() !== 'COUNTD' && ((column.get('columnType') === 'FUNCTION' && column.get('type') === 'TIMESPAN') ||
							(column.get('fieldObject') && column.get('fieldObject').get('type') === 'TIMESPAN'))) {
						isTimespan = true;
					}
				}
			}

			// get the threshold value
			if (threshold.range === 'LOW' || threshold.range === 'HIGH') {
				value = threshold.value1;
				if (isPercentage) {
					value += '%';
				} else if (isTimespan) {
					value = formatter(value);
				}
			} else {
				if (isPercentage) {
					value = threshold.value1 + '% - ' + threshold.value2 + '%';
				} else if (isTimespan) {
					value = formatter(threshold.value1) + ' - ' + formatter(threshold.value2);
				} else {
					value = threshold.value1 + ' - ' + threshold.value2;
				}
			}

			var range = 'Below';
			if (threshold.range === 'HIGH') {
				range = 'Above';
			} else if (threshold.range === 'IN_RANGE') {
				range = 'Within Range';
			} else if (threshold.range === 'OUT_RANGE') {
				range = 'Outside Range';
			}

			var schedule = 'Daily';
			if (threshold.schedule === 'WEEKLY') {
				schedule = 'Weekly';
			} else if (threshold.schedule === 'MONTHLY') {
				schedule = 'Monthly';
			}

			//namelink
			var namelink = {
				name: entity.getName(),
				domainId: entity.getDomainId(),
				isReport: isReport,
				id: entity.id,
				toString: function() {
					var name = this.name;
					//for some reason the 'this.name' is undefined in PhantomJS (I have 1.9.8 version)
					// and tests fail here. It might be related to this bug:
					//   https://github.com/ariya/phantomjs/issues/11722
					// so this is a work-around for now
					if (!name) {
						name = 'no-name';
					}
					return name.toLowerCase();
				}
			};

			//finally add the model corresponding to the entity
			this.data.push({
				entityViewType: entityViewTypeDiv,
				namelink: namelink,
				description: entity.getDescription(),
				dateModified: entity.getDateModified(),
				range: range,
				value: value,
				schedule: schedule,
				remove: remove,
				//additional properties
				id: entity.id,
				isReport: isReport
			});
		}
	});
});

